/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

export const UI_APPLICATION = 'UI_APPLICATION';
export const UI_OPERATIONS = 'UI_OPERATIONS';
export const UI_OPERATIONS_ALERTS = 'UI_OPERATIONS_ALERTS';
export const UI_OPERATIONS_SERVICES = 'UI_OPERATIONS_SERVICES';
export const UI_TEMPLATE = 'UI_TEMPLATE';
export const UI_PROFILE = 'UI_PROFILE';
export const UI_POLICIES = 'UI_POLICIES';
export const UI_GROUPS = 'UI_GROUPS';
export const UI_SECURITY = 'UI_SECURITY';
export const UI_SCRIPTS = 'UI_SCRIPTS';
export const UI_WAF = 'UI_WAF';
export const UI_ERRORPAGE = 'UI_ERRORPAGE';
export const UI_INFRASTRUCTURE = 'UI_INFRASTRUCTURE';
export const UI_INFRASTRUCTURE_DETAIL = 'UI_INFRASTRUCTURE_DETAIL';
export const UI_INFRASTRUCTURE_GSLB = 'UI_INFRASTRUCTURE_GSLB';
export const UI_ADMINISTRATION = 'UI_ADMINISTRATION';
export const UI_ACCOUNT = 'UI_ACCOUNT';
export const UI_CONTROLLER = 'UI_CONTROLLER';
export const UI_SUPPORT = 'UI_SUPPORT';
export const UI_HELP = 'UI_HELP';
export const UI_MAIN_MENU = 'UI_MAIN_MENU';
export const UI_NAVBAR = 'UI_NAVBAR';
export const UI_USER_MENU = 'UI_USER_MENU';
export const UI_EXTERNAL_SERVICES = 'UI_EXTERNAL_SERVICES';
